import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'
import useCommonTodo from '@/views/apps/todo/useCommonTodo'

export default function useDocumentAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { createItem } = useLambda()
    const { uploadFileToS3 } = useCommonTodo()
  const userData = store.state?.userStore?.userData
  const document = ref({})
  const isSubmitting = ref(false)
  const collection = 'document'

  const create = async (data, documentFile) => {
    isSubmitting.value = true

    const payload = {
      client_id: oid(userData.client.$oid),
      name: data.name?.value || ''
    }

    try {
      const item = await createItem({ collection, payload })
      if (!item) throw new Error('Item not created')
      
      // Upload file to AWS and then update the document in MongoDB with the AWS file key
      if (documentFile.name) {
        const documentId = item.insertedId
        const destinationFolder = `${userData.client.$oid}/documents`
        
        const key = await uploadFileToS3(documentFile, destinationFolder)
        
        updateDocumentWithKey(documentId, key)
      }
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.document_add_error'))
    } finally {
      router.push({ name: 'organization-document-list' })
      isSubmitting.value = false
    }
  }

  const updateDocumentWithKey = async (documentId, key) => {
    try {
      const query = { _id: oid(documentId) }
      const action = { $set: { key } }

      await updateItem({ collection, query, action })
      showSuccessMessage(i18n.t('message.document_added'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.document_add_error'))
    }
  }


  return {
    create,
    document,
    isSubmitting
  }
}
